export enum STEPS {
  KYC_VERIFICATION = 1,
  SHIPPING_DETAILS = 2,
}
